import React, { useEffect, useState } from "react";

const COOKIE_KEY = "cookieAccepted";

export default function CookieDisclaimer() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only show if not accepted
    const accepted = localStorage.getItem(COOKIE_KEY);
    setVisible(!accepted);
  }, []);

  function acceptCookies() {
    localStorage.setItem(COOKIE_KEY, "true");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-disclaimer">
      <div className="cookie-disclaimer__content">
        <span>
          This website uses cookies to ensure you get the best experience. By continuing to browse, you accept our use of cookies.
        </span>
        <button className="cookie-disclaimer__button" onClick={acceptCookies}>
          Accept
        </button>
      </div>
    </div>
  );
}
